import {useState, useCallback} from 'react';

function useFieldState<T>(
  defaultValue: T,
): [T, boolean, (arg1: T) => void, () => void] {
  const [value, setValue] = useState<T>(defaultValue);
  const [touched, setTouched] = useState<boolean>(false);
  const touch = useCallback(() => setTouched(true), [setTouched]);

  return [value, touched, setValue, touch];
}

export type FieldState<T> = {
  value: T;
  touched: boolean;
  handleValueChange: (arg1: T) => void;
  handleTouched: () => void;
};

export default useFieldState;
